const MuiTablePagination = {
  styleOverrides: {
    root: {
      borderBottom: 'none',
    },
  },
};

export default MuiTablePagination;
